var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 30,
    viewBox: "0 0 274 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 30,
    rx: 15,
    fill: "black",
    fillOpacity: 0.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 10.2821V19.4103",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.1394V19.2676",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 9.42627L26 20.8365",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.5657L22 18.6971",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.5657L10 18.6971",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.5657L14 18.6971",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5996 10.2821V19.4103",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2002 9.14099V20.5512",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4004 9.14099V20.5512",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64 10.2821L64 20.5513",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5996 10.2821L71.5996 20.5513",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83 10.2821L83 20.5513",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92 10.1394L92 20.4086",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45 11.4231L45 18.2692",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86 12.2788L86 19.125",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89 12.2788L89 19.125",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95 14.4182L95 16.5576",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4004 8L37.4004 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7998 8L48.7998 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5996 8L52.5996 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2002 8L60.2002 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7998 8L67.7998 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4004 8L75.4004 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2002 8L79.2002 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M118 10.2821V19.4103",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M106 10.1394V19.2676",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M114 9.42627L114 20.8365",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M110 11.5657L110 18.6971",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M98 11.5657L98 18.6971",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M102 11.5657L102 18.6971",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M121.6 10.2821V19.4103",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M129.2 9.14099V20.5512",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M144.4 9.14099V20.5512",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M152 10.2821L152 20.5513",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M159.6 10.2821L159.6 20.5513",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M171 10.2821L171 20.5513",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M180 10.1394L180 20.4086",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M133 11.4231L133 18.2692",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M174 12.2788L174 19.125",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M177 12.2788L177 19.125",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M183 14.4182L183 16.5576",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M125.4 8L125.4 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M136.8 8L136.8 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M140.6 8L140.6 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M148.2 8L148.2 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M155.8 8L155.8 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M163.4 8L163.4 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M167.2 8L167.2 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M206 10.2821V19.4103",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M194 10.1394V19.2676",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M202 9.42627L202 20.8365",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M198 11.5657L198 18.6971",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M186 11.5657L186 18.6971",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M190 11.5657L190 18.6971",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M209.6 10.2821V19.4103",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M217.2 9.14099V20.5512",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M232.4 9.14099V20.5512",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M240 10.2821L240 20.5513",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M247.6 10.2821L247.6 20.5513",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M261 10.1394L261 20.4086",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M221 11.4231L221 18.2692",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M258 12.2788L258 19.125",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M264 14.4182L264 16.5576",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M213.4 8L213.4 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M224.8 8L224.8 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M228.6 8L228.6 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M236.2 8L236.2 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M243.8 8L243.8 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M251.4 8L251.4 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M255.2 8L255.2 21.6923",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioWave);
export default __webpack_public_path__ + "static/media/audio-wave.d1e8d1c21de28f3f9813f2a81b23ab64.svg";
export { ForwardRef as ReactComponent };